import React from 'react';
import { useIntl } from 'react-intl';

import { Box } from '@atlaskit/primitives/compiled/box';
import SectionMessage from '@atlaskit/section-message/message';

import { i18n } from '../widgetMacroI18n.ts';

/**
 * Shown when the widget macro has no URL configured (neither a `url` parameter
 * nor a macro body fallback). Prompts the author to edit the macro and supply a
 * valid URL.
 */
export const EmptyState = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box testId="widget-macro-no-url">
			<SectionMessage appearance="warning">{formatMessage(i18n.urlNotSpecified)}</SectionMessage>
		</Box>
	);
};
